import { TblCol, TblFltOption } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import CreatedByRenderer from './renderers/CreatedByRenderer';
import ModifiedByRenderer from '../../../payor/list/table/renderers/ModifiedByRenderer';
import { iraYearOptions } from '../ira_view_models';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type ColKey =
    | ''
    | 'BIN'
    | 'PCN'
    | 'GroupNumber'
    | 'ContractYear'
    | 'CreatedCol'
    | 'CreatedBy'
    | 'CreatedDate'
    | 'ModifiedCol'
    | 'ModifiedBy'
    | 'ModifiedDate';

function contractYearOptions(): TblFltOption[] {
    const options = iraYearOptions();
    const result: TblFltOption[] = [{ lbl: 'ALL', val: '' }];
    options.forEach(opt => {
        result.push({ lbl: opt.lbl, val: opt.val });
    });
    return result;
}

// column spec (map the keys to the column types)
export function iraListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'BIN', { width: '35px' });
    tblSpecAddColumn<ColKey>(map, 'PCN', { width: '40px' });
    tblSpecAddColumn<ColKey>(map, 'GroupNumber', { title: 'Group Number', width: '40px' });
    tblSpecAddColumn<ColKey>(map, 'ContractYear', {
        type: 'DROPTEXT',
        title: 'Year',
        width: '40px',
        fltOptions: contractYearOptions(),
    });
    tblSpecAddColumn<ColKey>(map, 'CreatedBy', { title: 'Created By', width: '60px' }, CreatedByRenderer);
    tblSpecAddColumn<ColKey>(map, 'ModifiedBy', { title: 'Modified By', width: '60px' }, ModifiedByRenderer);
    return map;
}

// default view
export function iraListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Identifiers',
                cols: ['BIN', 'PCN', 'GroupNumber'],
            },
            {
                title: 'Plan Year(s)',
                cols: ['ContractYear'],
            },
            {
                title: 'Usage',
                cols: ['CreatedBy', 'ModifiedBy'],
            },
        ],
        sortby: 'BIN',
    };
}
